<template>
    <div class="checkbox-container">
        <div v-for="model in question.answers" v-bind:key="model.uid" style="line-height: 1;">
                  <input type="checkbox"
                         :name="question.uid + '[]'"
                         :value="model.uid"
                         v-bind:checked="model.selected"
                         v-on:click="handleCheckbox(model.uid)"
                  >
          <label class="checkbox-label" :for="question.uid" v-bind:class="{ selected: model.selected }">
            <span  v-on:click="handleCheckbox(model.uid)">{{ model.title }}</span>
            </label>
            <transition name="fade">
                <comment v-if="model.is_show_comment" :placeholder="model.comment_placeholder"
                         :name="model.comment_name"></comment>
            </transition>
            <br>
            <br>
        </div>
        <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
    </div>
</template>

<script>
    import Vue from 'vue';
    import Comment from './Comment';

    export default {
        name: 'radio',
        props: ['question'],
        data() {
            return {
                answerSelected: false,
                showComment: false,
                commentPlaceholder: false,
                commentName: false
            }
        },
        methods: {
            handleCheckbox: function (uid) {
                this.$emit("inputClick", uid);
                this.question.answers.forEach((item, index) => {
                    if (item.uid === uid) {

                        this.$emit("inputClick", uid);

                        item.selected = !item.selected;

                        this.$emit("checkDependency", uid);

                        if (item.is_allow_comment) {
                            /*const commentPlaceholder = item.comment_placeholder;
                            const commentName = 'comment_' + this.question.uid;*/
                            item.is_show_comment = !item.is_show_comment;
                            item.comment_name = 'answer_comment_' + item.uid;
                        }

                        Vue.set(this.question.answers, index, item);
                    }
                });
            }
        },
        components: {
            Comment
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .10s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }
</style>
